<nav class="bz-pagination" [attr.aria-label]="ariaLabel()">
  <button
    type="button"
    class="bz-pagination__step"
    [disabled]="currentPage() <= 1"
    (click)="goTo(currentPage() - 1)"
    aria-label="Previous page"
  >
    ‹
  </button>

  @for (item of items(); track item.key) {
    @if (item.page === null) {
      <span class="bz-pagination__gap" aria-hidden="true">…</span>
    } @else {
      <button
        type="button"
        class="bz-pagination__page"
        [class.bz-pagination__page--current]="item.page === currentPage()"
        [attr.aria-current]="item.page === currentPage() ? 'page' : null"
        [attr.aria-label]="'Page ' + item.page"
        (click)="goTo(item.page)"
      >
        {{ item.page }}
      </button>
    }
  }

  <button
    type="button"
    class="bz-pagination__step"
    [disabled]="currentPage() >= pageCount()"
    (click)="goTo(currentPage() + 1)"
    aria-label="Next page"
  >
    ›
  </button>
</nav>
